import  TopHeader from './head.vue'

TopHeader.install = function(Vue) {
  Vue.component('Head', TopHeader)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TopHeader)
}
export default TopHeader



// WEBPACK FOOTER //
// ./src/index.js